export const PRIVACY_POLICY_LABEL = 'Privacy Policy';

export const TERMS_AND_CONDITIONS_LABEL = 'Terms and conditions';

export const PRIVACY_POLICY_LINK = 'https://pland.co/privacy-policy';
